// src/components/common/PageHeader.jsx
import React from 'react';
import { Button } from '../ui/button';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';

const PageHeader = ({ title, description, action, secondaryAction, className }) => {
  return (
    <div className={cn('flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6', className)}>
      <div>
        <h1 className="text-3xl font-bold tracking-tight font-['Space_Grotesk']">{title}</h1>
        {description && (
          <p className="text-muted-foreground mt-1">{description}</p>
        )}
      </div>

      {/* Action Buttons Container */}
      <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap">
        {secondaryAction && (
          <Button 
            onClick={secondaryAction.onClick} 
            disabled={secondaryAction.disabled} 
            // variant={secondaryAction.variant || "outline"}
            className={cn("gap-2", secondaryAction.className)}
          >
            {secondaryAction.icon}
            {secondaryAction.label}
          </Button>
        )}
        
        {action && (
          <Button 
            onClick={action.onClick} 
            disabled={action.disabled} 
            className={cn("gap-2", action.className)}
          >
            {action.icon ? action.icon : <Plus className="h-4 w-4" />}
            {action.label}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;